import { PlaceOrderResponse } from './PlaceOrderResponse'
import { PlaceOrderRequest } from './PlaceOrderRequest'
import { gameConfig } from '../../../config'
import { apiClient, FeatureToggleV2Type, useFeatureToggleV2Store } from '@slot-nx/core'

export interface IPlaceOrderApi {
  placeOrder: (input: PlaceOrderRequest) => Promise<PlaceOrderResponse>
}

export const placeOrderApi: IPlaceOrderApi = {

  async placeOrder(input: PlaceOrderRequest): Promise<PlaceOrderResponse> {
    const enableSkipOngoingReplay = useFeatureToggleV2Store.getState().toggleListV2.has(FeatureToggleV2Type.enableSkipOngoingReplay)
    const endpoint = enableSkipOngoingReplay ? 'PlaceOrder' : 'PlaceOrderV2'
    const response = await apiClient.post<PlaceOrderResponse>(
      `${gameConfig.name}/${endpoint}`,
      input,
    )
    // return mock
    return response.data
  },
}

// const mock = {
//   gameResult: {
//     fgPayout: 0,
//     totalPayout: 0.5,
//     mgResult: {
//       dropList: [
//         {
//           dropTable: [
//             [
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//             ],
//             [
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//             ],
//             [
//               {
//                 type: 2,
//                 multiplier: 0,
//               },
//               {
//                 type: 1,
//                 multiplier: 0,
//               },
//               {
//                 type: 66,
//                 multiplier: 0,
//               },
//               {
//                 type: 7,
//                 multiplier: 0,
//               },
//               {
//                 type: 9,
//                 multiplier: 0,
//               },
//             ],
//             [
//               {
//                 type: 4,
//                 multiplier: 0,
//               },
//               {
//                 type: 3,
//                 multiplier: 0,
//               },
//               {
//                 type: 5,
//                 multiplier: 0,
//               },
//               {
//                 type: 1,
//                 multiplier: 0,
//               },
//               {
//                 type: 6,
//                 multiplier: 0,
//               },
//             ],
//             [
//               {
//                 type: 1,
//                 multiplier: 0,
//               },
//               {
//                 type: 2,
//                 multiplier: 0,
//               },
//               {
//                 type: 7,
//                 multiplier: 0,
//               },
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//               {
//                 type: 9,
//                 multiplier: 0,
//               },
//             ],
//             [
//               {
//                 type: 3,
//                 multiplier: 0,
//               },
//               {
//                 type: 1,
//                 multiplier: 0,
//               },
//               {
//                 type: 4,
//                 multiplier: 0,
//               },
//               {
//                 type: 5,
//                 multiplier: 0,
//               },
//               {
//                 type: 6,
//                 multiplier: 0,
//               },
//             ],
//           ],
//           finalTable: [
//             [
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//             ],
//             [
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//             ],
//             [
//               {
//                 type: 2,
//                 multiplier: 0,
//               },
//               {
//                 type: 1,
//                 multiplier: 0,
//               },
//               {
//                 type: 66,
//                 multiplier: 0,
//               },
//               {
//                 type: 7,
//                 multiplier: 0,
//               },
//               {
//                 type: 9,
//                 multiplier: 0,
//               },
//             ],
//             [
//               {
//                 type: 4,
//                 multiplier: 0,
//               },
//               {
//                 type: 3,
//                 multiplier: 0,
//               },
//               {
//                 type: 5,
//                 multiplier: 0,
//               },
//               {
//                 type: 1,
//                 multiplier: 0,
//               },
//               {
//                 type: 6,
//                 multiplier: 0,
//               },
//             ],
//             [
//               {
//                 type: 1,
//                 multiplier: 0,
//               },
//               {
//                 type: 2,
//                 multiplier: 0,
//               },
//               {
//                 type: 7,
//                 multiplier: 0,
//               },
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//               {
//                 type: 9,
//                 multiplier: 0,
//               },
//             ],
//             [
//               {
//                 type: 3,
//                 multiplier: 0,
//               },
//               {
//                 type: 1,
//                 multiplier: 0,
//               },
//               {
//                 type: 4,
//                 multiplier: 0,
//               },
//               {
//                 type: 5,
//                 multiplier: 0,
//               },
//               {
//                 type: 6,
//                 multiplier: 0,
//               },
//             ],
//           ],
//           winLineList: [
//             {
//               type: 8,
//               count: 11,
//               removedPositions: [
//                 [
//                   0,
//                   1,
//                   2,
//                   3,
//                   4,
//                 ],
//                 [
//                   0,
//                   1,
//                   2,
//                   3,
//                   4,
//                 ],
//                 [],
//                 [],
//                 [
//                   3,
//                 ],
//                 [],
//               ],
//               winPositions: [
//                 [
//                   0,
//                   1,
//                   2,
//                   3,
//                   4,
//                 ],
//                 [
//                   0,
//                   1,
//                   2,
//                   3,
//                   4,
//                 ],
//                 [],
//                 [],
//                 [
//                   3,
//                 ],
//                 [],
//               ],
//               changeSymbols: [],
//               payout: 0.5,
//             },
//           ],
//           totalWinPositions: [
//             [
//               0,
//               1,
//               2,
//               3,
//               4,
//             ],
//             [
//               0,
//               1,
//               2,
//               3,
//               4,
//             ],
//             [],
//             [],
//             [
//               3,
//             ],
//             [],
//           ],
//           payout: 0.5,
//           giftedSymbols: [],
//           expandingSymbols: [],
//           isExpanding: false,
//           isGiveWild: false,
//           isGiveMultiplier: false,
//         },
//         {
//           dropTable: [
//             [
//               {
//                 type: 4,
//                 multiplier: 0,
//               },
//               {
//                 type: 6,
//                 multiplier: 0,
//               },
//               {
//                 type: 6,
//                 multiplier: 0,
//               },
//               {
//                 type: 5,
//                 multiplier: 0,
//               },
//               {
//                 type: 66,
//                 multiplier: 0,
//               },
//             ],
//             [
//               {
//                 type: 4,
//                 multiplier: 0,
//               },
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//               {
//                 type: 7,
//                 multiplier: 0,
//               },
//               {
//                 type: 7,
//                 multiplier: 0,
//               },
//             ],
//             [],
//             [],
//             [
//               {
//                 type: 5,
//                 multiplier: 0,
//               },
//             ],
//             [],
//           ],
//           finalTable: [
//             [
//               {
//                 type: 4,
//                 multiplier: 0,
//               },
//               {
//                 type: 6,
//                 multiplier: 0,
//               },
//               {
//                 type: 6,
//                 multiplier: 0,
//               },
//               {
//                 type: 5,
//                 multiplier: 0,
//               },
//               {
//                 type: 66,
//                 multiplier: 0,
//               },
//             ],
//             [
//               {
//                 type: 4,
//                 multiplier: 0,
//               },
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//               {
//                 type: 8,
//                 multiplier: 0,
//               },
//               {
//                 type: 7,
//                 multiplier: 0,
//               },
//               {
//                 type: 7,
//                 multiplier: 0,
//               },
//             ],
//             [
//               {
//                 type: 2,
//                 multiplier: 0,
//               },
//               {
//                 type: 1,
//                 multiplier: 0,
//               },
//               {
//                 type: 66,
//                 multiplier: 0,
//               },
//               {
//                 type: 7,
//                 multiplier: 0,
//               },
//               {
//                 type: 9,
//                 multiplier: 0,
//               },
//             ],
//             [
//               {
//                 type: 4,
//                 multiplier: 0,
//               },
//               {
//                 type: 3,
//                 multiplier: 0,
//               },
//               {
//                 type: 5,
//                 multiplier: 0,
//               },
//               {
//                 type: 1,
//                 multiplier: 0,
//               },
//               {
//                 type: 6,
//                 multiplier: 0,
//               },
//             ],
//             [
//               {
//                 type: 5,
//                 multiplier: 0,
//               },
//               {
//                 type: 1,
//                 multiplier: 0,
//               },
//               {
//                 type: 2,
//                 multiplier: 0,
//               },
//               {
//                 type: 7,
//                 multiplier: 0,
//               },
//               {
//                 type: 9,
//                 multiplier: 0,
//               },
//             ],
//             [
//               {
//                 type: 3,
//                 multiplier: 0,
//               },
//               {
//                 type: 1,
//                 multiplier: 0,
//               },
//               {
//                 type: 4,
//                 multiplier: 0,
//               },
//               {
//                 type: 5,
//                 multiplier: 0,
//               },
//               {
//                 type: 6,
//                 multiplier: 0,
//               },
//             ],
//           ],
//           winLineList: [],
//           totalWinPositions: [],
//           payout: 0,
//           giftedSymbols: [],
//           expandingSymbols: [],
//           isExpanding: false,
//           isGiveWild: false,
//           isGiveMultiplier: false,
//         },
//       ],
//       betLevel: 0.05,
//       odds: 0.5,
//       basePayout: 0.5,
//       payout: 0.5,
//       playStake: 1,
//       freeGameType: 0,
//       fgAddTimes: 0,
//       potActionList: [],
//       multiplierList: [],
//       spinMultiplier: 0,
//       totalMultiplier: 1,
//       accMultiplier: 0,
//     },
//     fgResultList: [],
//   },
//   refNo: '200001010877',
//   placedBalance: 994.75,
//   balance: 995.25,
//   godziDropResult: {
//     effectiveStake: 0,
//     type: 'None',
//     prize: 0,
//     gameResultList: [],
//     freeSpinCount: 0,
//     payout: 0,
//     winLose: 0,
//   },
//   slotVoucherSummary: null,
//   returnCode: 0,
//   message: '',
// }
